import { forwardRef, useEffect, useImperativeHandle } from 'react'

import * as Cesium from '@cesiumgs/cesium-analytics'
import useStore from '@/hooks/useStore'
import './index.less'

const prefix = 'perspective'
let leftMouse: any = null
let flyTopoint: any = null
let flyToposition: any = null
let flyToorientation: any = null
const Perspective = forwardRef((props, ref) => {
  const mapStore = useStore('mapStore')
  useImperativeHandle(ref, () => ({
    handleClearAll,
  }))
  useEffect(() => {
    handleDrawPoint()
    return () => {
      handleClearAll()
    }
  }, [])

  const handleDrawPoint = () => {
    leftMouse = new Cesium.ScreenSpaceEventHandler(
      (mapStore.viewer as Cesium.Viewer).scene.canvas,
    )
    flyToposition = {
      lng: Cesium.Math.toDegrees(
        (mapStore.viewer as Cesium.Viewer).camera.positionCartographic.longitude,
      ),
      lat: Cesium.Math.toDegrees(
        (mapStore.viewer as Cesium.Viewer).camera.positionCartographic.latitude,
      ),
      alt: (mapStore.viewer as Cesium.Viewer).camera.positionCartographic.height,
    }
    flyToorientation = {
      heading: (mapStore.viewer as Cesium.Viewer).camera.heading,
      pitch: (mapStore.viewer as Cesium.Viewer).camera.pitch,
      roll: (mapStore.viewer as Cesium.Viewer).camera.roll,
    }
    // let point = null;
    leftMouse.setInputAction((movement: any) => {
      const position = mapStore.viewer ? mapStore.viewer.scene.pickPosition(movement.position) : null
      if (!position)
        return
      const A = getcameraPosInfo()
      const jssuan = getHeading(A as Cesium.Cartesian3, position)
      const newgetHeading = (jssuan + 180) % 360
      const cartographic = Cesium.Cartographic.fromCartesian(position)
      const lon = Cesium.Math.toDegrees(cartographic.longitude)
      const lat = Cesium.Math.toDegrees(cartographic.latitude)
      const came = {
        heading: Cesium.Math.toRadians(newgetHeading),
        pitch: Cesium.Math.toRadians(0), // Cesium.Math.toRadians(-10.0),
        roll: 0.0,
      }
      if (flyTopoint && mapStore.viewer)
        mapStore.viewer.entities.remove(flyTopoint)
      flyTopoint = mapStore.viewer
        ? mapStore.viewer.entities.add(
          new Cesium.Entity({
            name: 'point',
            position: Cesium.Cartesian3.fromDegrees(
              lon,
              lat,
              cartographic.height,
            ),
            point: {
              pixelSize: 5,
              outlineColor: Cesium.Color.YELLOW,
              outlineWidth: 3,
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
            },
          }),
        )
        : null
      flyTopoint.viewFrom = new Cesium.Cartesian3(10, 10, 0);
      (mapStore.viewer as Cesium.Viewer).trackedEntity = flyTopoint;
      (mapStore.viewer as Cesium.Viewer).camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          lon,
          lat,
          cartographic.height + 10,
        ),
        orientation: came,
        complete: () => {},
      })
      if (mapStore.viewer) {
        mapStore.viewer.scene.screenSpaceCameraController.enableTranslate
          = false
        mapStore.viewer.scene.screenSpaceCameraController.enableZoom = false
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
  }
  const handleClearAll = () => {
    if (leftMouse) {
      leftMouse.destroy()
      leftMouse = null
      if (flyTopoint)
        (mapStore.viewer as Cesium.Viewer).entities.remove(flyTopoint);
      (mapStore.viewer as Cesium.Viewer).trackedEntity = undefined;
      (mapStore.viewer as Cesium.Viewer).camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      (mapStore.viewer as Cesium.Viewer).scene.screenSpaceCameraController.enableTranslate = true;
      (mapStore.viewer as Cesium.Viewer).scene.screenSpaceCameraController.enableZoom = true;
      (mapStore.viewer as Cesium.Viewer).camera.setView({
        destination: Cesium.Cartesian3.fromDegrees(
          flyToposition.lng,
          flyToposition.lat,
          flyToposition.alt,
        ),
        orientation: {
          //
          heading: flyToorientation.heading,
          //
          pitch: flyToorientation.pitch,
          roll: flyToorientation.roll,
        },
      })
    }
  }
  const getcameraPosInfo = () => {
    if (mapStore.viewer) {
      const position = mapStore.viewer.scene.camera.positionCartographic // with longitude and latitude expressed in radians and height in meters.
      const longitude = Cesium.Math.toDegrees(position.longitude).toFixed(6)
      const latitude = Cesium.Math.toDegrees(position.latitude).toFixed(6)
      const height = position.height
      return Cesium.Cartesian3.fromDegrees(
        Number(longitude),
        Number(latitude),
        height,
      )
    }
  }
  const getHeading = (pointA: Cesium.Cartesian3, pointB: Cesium.Cartesian3): number => {
    const transform = Cesium.Transforms.eastNorthUpToFixedFrame(pointA)

    const positionvector = Cesium.Cartesian3.subtract(
      pointB,
      pointA,
      new Cesium.Cartesian3(),
    )

    const vector = Cesium.Matrix4.multiplyByPointAsVector(
      Cesium.Matrix4.inverse(transform, new Cesium.Matrix4()),
      positionvector,
      new Cesium.Cartesian3(),
    )

    const direction = Cesium.Cartesian3.normalize(
      vector,
      new Cesium.Cartesian3(),
    )
    // heading
    const heading
      = Math.atan2(direction.y, direction.x) - Cesium.Math.PI_OVER_TWO
    return (
      (Cesium.Math.TWO_PI - Cesium.Math.zeroToTwoPi(heading)) * (180 / Math.PI)
    )
  }

  return (
    <>

      <div className={`${prefix}`}>
        <div className={`${prefix}-txt`}>
          시점 지정
          <span>* 시점을 지도에서 선택하세요</span>
        </div>

      </div>
    </>
  )
})

export default Perspective
